export default __webpack_public_path__ + "static/media/RDS.4fefdbad.svg";